import { render } from "./NewOtherCompanyMail.vue?vue&type=template&id=320ea866"
import script from "./NewOtherCompanyMail.vue?vue&type=script&lang=js"
export * from "./NewOtherCompanyMail.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__